"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiasTapeSchema = void 0;
const yup = __importStar(require("yup"));
const bta = __importStar(require("../attributes/biasTapeAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.BiasTapeSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes['Bias Tape']),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(bta.SellingUnit)),
    widthIn: yup
        .number()
        .positive()
        .transform(utils_1.NaNtoUndefined)
        .test(utils_1.decimalsTest(6))
        .max(100)
        .required(),
    lengthM: shared.widthLengthBaseSchema.max(200).required(),
    biasTapeLengthType: utils_1.reqSelectOneSchema(Object.values(bta.KnownOrEstimated)),
    quantity: shared.quantitySchema.required(),
    material: utils_1.reqSelectOneSchema(Object.values(bta.Material)),
    biasTapeType: shared.titleSetLargeSchema.required(),
    qualities: yup
        .array(shared.titleSetLargeSchema)
        .default([])
        .max(3)
        .optional(),
    brand: shared.titleSetLargeSchema.optional(),
    additionalInfo: shared.sentenceSetSchema.optional(),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    price: shared.priceSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case bta.SellingUnit.Package:
            return schema.omit(['biasTapeLengthType']);
        case bta.SellingUnit['By Meter']:
            return schema.omit([
                'lengthM',
                'brand',
                'additionalInfo',
                'biasTapeLengthType'
            ]);
        case bta.SellingUnit.Roll:
            return schema.omit(['brand', 'additionalInfo']);
        default:
            return schema.omit(['brand', 'additionalInfo', 'biasTapeLengthType']);
    }
})
    .test('Context Check', "Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=biasTapeSchema.js.map